import { render, staticRenderFns } from "./storeThumbnail.vue?vue&type=template&id=a8ec7d76&scoped=true"
import script from "./storeThumbnail.vue?vue&type=script&lang=js"
export * from "./storeThumbnail.vue?vue&type=script&lang=js"
import style0 from "./storeThumbnail.vue?vue&type=style&index=0&id=a8ec7d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ec7d76",
  null
  
)

export default component.exports